import { Component, Input, OnInit, Optional, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EfxDataSource } from "@signal/component-library/efx-data-table";
import { BuscadorService } from 'src/app/services/shared/buscador/buscador.service';
import { LogService } from 'src/app/services/shared/logs/log.service';
import { EfxPagedAndSortingDataSource } from 'src/app/utils/data-table.service';
import { I18nService } from '@signal/component-library';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LogFilterData } from 'src/app/interfaces/shared/log-filter-data.interface';
import { CommonModule } from '@angular/common';
import { SignalDesignModule } from 'src/app/signal-design/signal-design.module';
import { SharedModule } from 'src/app/components/shared/shared.module';

@Component({
    selector: 'app-logs',
    templateUrl: './logs.component.html',
    styleUrls: ['./logs.component.scss'],
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormsModule, SignalDesignModule, SharedModule]
})
export class LogsComponent implements OnInit {

  @Input() isModalContext: boolean = false;
  @Input() initialMatchKey: any;

  form: FormGroup;
  dataSource: EfxDataSource;

  dateStartUI: string = '';
  dateEndUI: string = '';

  initData: boolean = false;
  maxDate: any = '';
  data: any = [];
  pagesSize = [20, 40, 60, 80, 100];
  pageSize: number = 20;
  pageNumber: number = 0;
  length: number = 0;
  columns = [
    { field: 'fecha', header: 'Fecha', isSortable: true },
    { field: 'usuario', header: 'Usuario', isSortable: true },
    { field: 'dominio', header: 'Dominio', isSortable: true },
    { field: 'fuente', header: 'Subdominio', isSortable: true },
    { field: 'origen', header: 'Origen', isSortable: true },
    { field: 'operation', header: 'Operación', isSortable: true },
  ];
  currentBodyForRequest: any;
  copySuccess: boolean = false;

  constructor(
    private fb: FormBuilder,
    private logService: LogService,
    private buscadoSearch: BuscadorService,
    private i18nService: I18nService,
    @Optional() public activeModal: MatDialogRef<LogsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    if (dialogData) {
      this.isModalContext = dialogData.isModalContext || false;
      this.initialMatchKey = dialogData.initialMatchKey;
    }
    // Si estamos en contexto modal (botón Movimientos), usar pageSize de 100
    if (this.isModalContext) {
      this.pageSize = 100;
    }
    this.form = this.fb.group({
      user: [''],
      datepicker: [],
      numberdocuments: [''],
      origen: [''],
      source: ['']
    });
    this.i18nService.setDateFormat('DD/MM/YYYY');
  }

  ngOnInit(): void {
    this.initDataSource();
    if (this.isModalContext) {
      this.setDataAndFetchForModal();
    }

    this.dataSource.pagingSubject.subscribe(
      (currentPage) => {
        if (Number(currentPage) - 1 > this.pageNumber) {
          this.pageNumber = Number(currentPage) - 1;
          this.onGetLogs(this.currentBodyForRequest)
        } else {
          if (this.data.length > 0 && this.pageNumber > 0) {
            this.dataSource.setTotalRows(this.length)
          }
        }

      },
      (e) => console.error('error on page change')
    );
  }

  chagenPageSize(event) {
    this.pageSize = event.target.value;
    this.dataSource.setPageSize(this.pageSize);
    this.data = [];
    this.onSetFilter();
  }

  initDataSource() {

    this.maxDate = new Date();
    this.dataSource = new EfxPagedAndSortingDataSource();
  }

  onRowExpanded(event) {
    // console.log("event ------>", event);
  }

  onCloseAllExpanded() {
    this.dataSource.refresh();
    this.dataSource.deselectAll()
    this.dataSource?.originalRows.forEach((row) => {
      row.isExpanded = false;
      row.isNestedRowExpanded = false;
    });
  }

  logFormValidationErrors() {
    console.log('Estado del formulario:', this.form.status);
    console.log('Valor del formulario:', this.form.value);
    Object.keys(this.form.controls).forEach(key => {
      const controlErrors = this.form.get(key).errors;
      if (controlErrors != null) {
        console.log('Control:', key, ', errores:', controlErrors);
      }
    });
  }

  setDataAndFetchForModal() {
    // console.log("Preparando datos para el modo modal...");
    const startDate = new Date(2023, 0, 1);
    const endDate = new Date();

    const startDateForAPI = startDate.toISOString();
    const finalEndDate = new Date(endDate.getTime());
    finalEndDate.setUTCHours(23, 59, 59, 999);
    const endDateForAPI = finalEndDate.toISOString();

    const modalFilterCriteria: LogFilterData = {
      matchKey: this.initialMatchKey
    };

    this.prepareAndFetchLogs(modalFilterCriteria, startDateForAPI, endDateForAPI);
  }

  onSetFilter() {
    if (this.isModalContext) {
      console.warn("onSetFilter llamado incorrectamente en contexto modal.");
      return;
    }

    if (!this.form.valid) {
      console.warn('Formulario no válido. No se puede filtrar.');
      this.logFormValidationErrors();
      return;
    }

    const { value } = this.form;
    const { enddatepicker, startdatepicker, source, user, numberdocuments, origen } = value;

    let startDateForAPI: string | null = null;
    let endDateForAPI: string | null = null;

    this.dateStartUI = '';
    this.dateEndUI = '';

    if (startdatepicker instanceof Date && enddatepicker instanceof Date) {
      startDateForAPI = startdatepicker.toISOString();
      const finalEndDate = new Date(enddatepicker.getTime());
      finalEndDate.setUTCHours(23, 59, 59, 999);
      endDateForAPI = finalEndDate.toISOString();

      const dateStartParts = startDateForAPI.split('T')[0].split('-');
      const dateEndParts = endDateForAPI.split('T')[0].split('-');
      this.dateStartUI = `${dateStartParts[2]}/${dateStartParts[1]}/${dateStartParts[0]}`;
      this.dateEndUI = `${dateEndParts[2]}/${dateEndParts[1]}/${dateEndParts[0]}`;
    }

    const filterCriteria: LogFilterData = {
      user: user,
      source: source,
      origen: origen,
      numberdocuments: numberdocuments
    };

    this.prepareAndFetchLogs(filterCriteria, startDateForAPI, endDateForAPI);
  }

  private prepareAndFetchLogs(filters: LogFilterData, startDateISO?: string | null, endDateISO?: string | null) {
    this.data = [];
    this.pageNumber = 0;

    if (!this.isModalContext) {
      if (startDateISO && endDateISO) {
        const dateStartParts = startDateISO.split('T')[0].split('-');
        const dateEndParts = endDateISO.split('T')[0].split('-');
        this.dateStartUI = `${dateStartParts[2]}/${dateStartParts[1]}/${dateStartParts[0]}`;
        this.dateEndUI = `${dateEndParts[2]}/${dateEndParts[1]}/${dateEndParts[0]}`;
      } else {
        this.dateStartUI = '';
        this.dateEndUI = '';
      }
    }

    const body: any = {};

    if (startDateISO && endDateISO) {
      //console.log('prepareAndFetchLogs - AñADIENDO fechas al body.');
      body.startDate = startDateISO;
      body.endDate = endDateISO;
    } else {
      console.warn('prepareAndFetchLogs - NO se añadieron fechas al body porque startDateISO o endDateISO (o ambos) son null/undefined.');
    }

    if (filters.user?.trim()) {
      body["user"] = filters.user.trim();
    }
    if (filters.source?.trim()) {
      body["source"] = filters.source.trim();
    }
    if (filters.origen?.trim()) {
      body["origen"] = filters.origen.trim();
    }
    if (this.isModalContext && filters.matchKey) {
      body["matchKey"] = filters.matchKey;
    }

    this.currentBodyForRequest = { ...body };
    //console.log('prepareAndFetchLogs - currentBodyForRequest FINAL:', this.currentBodyForRequest);

    const documentNumberToProcess = filters.numberdocuments;

    if (documentNumberToProcess?.trim()) {
      this.buscadoSearch.getEncodeMkService(documentNumberToProcess.trim()).subscribe(
        result => {
          if (result && result.hash) {
            this.currentBodyForRequest["document_hash"] = result.hash;
          }
          // console.log('Body para API (con hash potencial):', this.currentBodyForRequest);
          this.onGetLogs(this.currentBodyForRequest);
        },
        (error) => {
          console.error('Error en getEncodeMkService:', error);
          // console.log('Body para API (error en hash):', this.currentBodyForRequest);
          this.onGetLogs(this.currentBodyForRequest);
        }
      );
    } else {
      // console.log('Body para API (sin número de documento):', this.currentBodyForRequest);
      this.onGetLogs(this.currentBodyForRequest);
    }
  }

  onGetLogs(body) {
    this.logService.getLogs(body, this.pageSize, this.pageNumber).subscribe(dataLogs => {
      const data = [];
      if (dataLogs) {
        dataLogs.logs.forEach((log, i: number) => {
          const fecha = new Date(log.operator.date);
          fecha.setDate(fecha.getDate());
          const day = String(fecha.getDate()).padStart(2, '0');
          const month = String(fecha.getMonth() + 1).padStart(2, '0');
          const year = fecha.getFullYear();
          const hours = String(fecha.getHours()).padStart(2, '0');
          const minutes = String(fecha.getMinutes()).padStart(2, '0');
          const fechaFormat = `${day}/${month}/${year} ${hours}:${minutes}`;
          const key = Object.keys(log.changes.fields);

          const change = [];

          if (key) {
            key.forEach(value => {
              change.push({
                name: value,
                before: log.changes.fields[value].before !== null ? log.changes.fields[value].before : "null",
                after: log.changes.fields[value].after !== null ? log.changes.fields[value].after : "null",
              })
            })
          }

          const mov = this.data.length === 0 ? `${i + 1}` : (this.data.length + i)
          data.push({
            mov,
            fecha: fechaFormat,
            fechaTimestamp: fecha.getTime(),
            nombre: `${log.identifier.name}`,
            documento: `${log.identifier.document}`,
            usuario: `${log.operator.user}`,
            dominio: `${log.operator.domain}`,
            fuente: `${log.operator.subdomain}`,
            origen: log.operator.origen ? `${log.operator.origen}` : '',
            operation: `${log.changes.operation}`,
            motivo1: 'CAN',
            motivo2: '-',
            change,
            requestId: log.changes.requestId ? `${log.changes.requestId}` : '',
            criterio: log.changes.criterios ? `${log.changes.criterios}` : '',
            comentarios: log.changes.comentarios ? `${log.changes.comentarios}` : '',
            logDetail: this.formatLogDetail(log),
            logDetailRaw: JSON.stringify(log, null, 2),
          })
        })

      }
      this.dataSource.clear();

      this.data = this.data.length === 0 ? data : this.data.concat(data);

      // Ordenar por fecha descendente (mas nuevo primero)
      this.data.sort((a, b) => b.fechaTimestamp - a.fechaTimestamp);

      this.dataSource.setData(this.data);
      this.dataSource.setPageSize(this.pageSize);

      if (dataLogs.hasOwnProperty("nextPage")) {
        this.length = dataLogs.nextPage ? this.data.length + 1 : this.data.length;
        this.dataSource.goToPage(this.pageNumber + 1);
      } else {
        this.length = this.data.length;
      }

      this.dataSource.setTotalRows(this.length);
      this.initData = true;
    })

  }

  onDownload() {
    const csvData = this.convertArrayCSV(this.data);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'logs.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  convertArrayCSV(data: any[]): string {
    if (!data || data.length === 0) {
      return '';
    }
    const separador = ',';
    const keys = Object.keys(data[0]);
    const csvHeader = keys.join(separador);
    const csvRows = data.map(row => {
      return keys.map(key => {
        let cell = row[key] === null || row[key] === undefined ? '' : row[key];
        cell = Array.isArray(cell) ? JSON.stringify(cell).replace(/"/g, '""') : String(cell).replace(/"/g, '""');
        if (cell.includes(separador) || cell.includes('"') || cell.includes('\n')) {
          cell = `"${cell}"`;
        }
        return cell;
      }).join(separador);
    });
    return [csvHeader, ...csvRows].join('\n');
  }

  downloadAllLogs(body: any, pageNumber: number = 0, allLogs: any[] = []) {
    this.logService.getLogs(body, 1500, pageNumber).subscribe(dataLogs => {
      if (!dataLogs || !dataLogs.logs || dataLogs.logs.length === 0) {
        // No hay más datos. Finaliza la recursión y procesa los logs acumulados.
        this.processAndDownload(allLogs);
        return;
      }

      // Procesa los logs de la página actual
      const processedLogs = this.processLogsForDownload(dataLogs.logs);
      allLogs = allLogs.concat(processedLogs);

      // Si hay una siguiente página, llama a la función de nuevo con la siguiente página.
      if (dataLogs.nextPage) {
        this.downloadAllLogs(body, pageNumber + 1, allLogs);
      } else {
        // No hay más páginas. Procesa los logs acumulados.
        this.processAndDownload(allLogs);
      }
    }, error => {
      console.error('Error al obtener los logs para la descarga:', error);
      // Manejo de errores
    });
  }

  processLogsForDownload(logs: any[]): any[] {
    const processedData: any[] = [];
    logs.forEach(log => {
      // Formatear la fecha
      const date = new Date(log.operator.date);
      const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
      const formattedTime = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;

      const changes = Object.keys(log.changes.fields || {})
        .map(key => {
          const before = log.changes.fields[key].before !== null ? log.changes.fields[key].before : "null";
          const after = log.changes.fields[key].after !== null ? log.changes.fields[key].after : "null";
          return `Campo: ${key} | Valor Anterior: ${before} | Valor Nuevo: ${after}`;
        })
        .join('; ');

      processedData.push({
        'Fecha': formattedDate,
        'Hora': formattedTime,
        'N° de Documento': log.identifier.document || '',
        'Nombre': log.identifier.name || '',
        'Usuario': log.operator.user || '',
        'Dominio': log.operator.domain || '',
        'Subdominio': log.operator.subdomain || '',
        'Origen': log.operator.origen || '',
        'Operación': log.changes.operation || '',
        'Request ID': log.changes.requestId || '',
        'Comentarios': log.changes.comentarios || '',
        'Campos Modificados': changes,
        'Criterios': log.changes.criterios || '',
        'MatchKey': log.identifier.matchKey || ''
//        'Matriz': log.operator.matriz || '',
      });
    });
    return processedData;
  }

  processAndDownload(data: any[]) {
    if (data.length === 0) {
      console.warn('No hay datos para descargar.');
      return;
    }

    let fileName = '';

    if (this.dateStartUI && this.dateEndUI) {
      const formattedStartDate = this.dateStartUI.replace(/\//g, '-');
      const formattedEndDate = this.dateEndUI.replace(/\//g, '-');
      fileName = `DM_Logs_${formattedStartDate}_al_${formattedEndDate}.csv`;
    } else {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Add 1 because months start at 0
      const year = today.getFullYear();
      fileName = `DM_Logs_${day}-${month}-${year}.csv`;
    }

    const csvData = this.convertArrayCSV(data);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  private readonly hiddenKeys = new Set(['document_hash', 'matriz']);

  private shouldHideField(key: string, value: any, parentKey?: string): boolean {
    if (this.hiddenKeys.has(key)) return true;
    if (parentKey === 'fields' && value && typeof value === 'object' && !Array.isArray(value)) {
      const before = value.before !== undefined ? value.before : null;
      const after = value.after !== undefined ? value.after : null;
      if (before === after) return true;
      if (String(before) === String(after)) return true;
    }
    return false;
  }

  private formatLogDetail(log: any): string {
    const sections: string[] = [];

    if (log.identifier) {
      const identifierContent = this.formatSection(log.identifier, 'identifier');
      if (identifierContent) {
        sections.push(this.wrapSection('Identificador', identifierContent));
      }
    }

    if (log.changes) {
      // Pasamos el log completo para que podamos detectar si el identificador tiene múltiples matchKey
      // También pasamos la operación para casos especiales como "RDS Modif"
      const operation = log.changes?.operation || '';
      const changesContent = this.formatChangesSection(log.changes, log, operation);
      if (changesContent) {
        sections.push(this.wrapSection('Cambios', changesContent));
      }
    }

    if (log.operator) {
      const operatorContent = this.formatSection(log.operator, 'operator');
      if (operatorContent) {
        sections.push(this.wrapSection('Operador', operatorContent));
      }
    }

    return sections.join('');
  }

  private wrapSection(title: string, content: string, collapsed: boolean = false): string {
    const openAttr = collapsed ? '' : ' open';
    return `<details class="log-section"${openAttr}>` +
      `<summary class="log-section-header">${title}</summary>` +
      `<div class="log-section-body">${content}</div>` +
      `</details>`;
  }

  private formatChangesSection(changes: any, parentLog?: any, operation?: string): string {
     const lines: string[] = [];

     // Si la operación es "RDS Modif", mostrar solo el valor after (sin before ni flecha)
     const isRdsModif = operation && operation.trim().toLowerCase() === 'rds modif';

     // Detectar si el log (identifier) tiene múltiples matchKey — en ese caso consideramos una edición masiva global
     const identifierMatchItems = parentLog && parentLog.identifier ? this.extractMatchKeyItems(parentLog.identifier.matchKey) : null;

     // No usamos comentarios para decidir si es edición masiva. Solo se considera masiva cuando
     // existen múltiples matchKeys reales en identifier.matchKey o en changes.fields.matchKey.

     // También detectar si en changes.fields existe un matchKey con after multiple -> considerar edición masiva
     let fieldsIndicateMassive = false;
     if (changes && changes.fields && typeof changes.fields === 'object') {
       const mkField = Object.keys(changes.fields).find(k => k && (k.toLowerCase() === 'matchkey' || k.toLowerCase() === 'match_key'));
       if (mkField) {
         const mkAfter = changes.fields[mkField] && changes.fields[mkField].after ? changes.fields[mkField].after : null;
         const mkAfterItems = this.extractMatchKeyItems(mkAfter);
         fieldsIndicateMassive = mkAfterItems && mkAfterItems.length > 1;
       }
     }

     // Solo consideramos como edición masiva global si detectamos múltiples matchKeys reales (identifier o campo matchKey)
     const isGlobalMassive = (identifierMatchItems && identifierMatchItems.length > 1) || fieldsIndicateMassive;

     // Campos con inline diff
     if (changes.fields && typeof changes.fields === 'object') {
       const fieldKeys = Object.keys(changes.fields);
       const visibleFields = fieldKeys.filter(k => !this.shouldHideField(k, changes.fields[k], 'fields'));
       if (visibleFields.length > 0) {
         visibleFields.forEach(fieldName => {
           const field = changes.fields[fieldName];
           // Normalizar valores: tratar la string 'null' (o 'NULL') como null
           const rawBefore = field.before !== undefined ? field.before : null;
           const rawAfter = field.after !== undefined ? field.after : null;
           const before = rawBefore === null || String(rawBefore).trim().toLowerCase() === 'null' ? null : rawBefore;
           const after = rawAfter === null || String(rawAfter).trim().toLowerCase() === 'null' ? null : rawAfter;

           // Detectar caso: edición masiva de matchkey (antes null y despues múltiples matchkeys)
           const afterItems = this.extractMatchKeyItems(after);
           const beforeItems = this.extractMatchKeyItems(before);
           const isMatchKeyField = fieldName && (fieldName.toLowerCase() === 'matchkey' || fieldName.toLowerCase() === 'match_key');

           const isMassiveMatchKeyCase = isMatchKeyField && (before === null) && afterItems && afterItems.length > 1;

           if (isMassiveMatchKeyCase) {
             // Mostrar solo los badges del after, sin before ni flecha
             const badges = this.renderBadges(afterItems);
             lines.push(`<div class="log-diff-line"><span class="log-key">${this.escapeHtml(fieldName)}</span>: ${badges}</div>`);
             return; // next field
           }

           // Si es campo matchKey y antes/despues contienen items o strings, renderizar como badges (sin comillas)
           if (isMatchKeyField) {
             let beforeHtmlBadge = '';
             if (before !== null && before !== undefined) {
               const bItems = beforeItems || this.extractMatchKeyItems(before);
               if (bItems && bItems.length > 0) {
                 beforeHtmlBadge = this.renderBadges(bItems);
               } else if (String(before).trim() !== 'null') {
                 beforeHtmlBadge = this.renderSingleBadge(String(before));
               }
             }

             let afterHtmlBadge = '';
             if (after !== null && after !== undefined) {
               const aItems = afterItems || this.extractMatchKeyItems(after);
               if (aItems && aItems.length > 0) {
                 afterHtmlBadge = this.renderBadges(aItems);
               } else if (String(after).trim() !== 'null') {
                 afterHtmlBadge = this.renderSingleBadge(String(after));
               }
             }

             // Si es "RDS Modif", mostrar solo after (sin before ni flecha)
             if (isRdsModif) {
               if (afterHtmlBadge) {
                 lines.push(`<div class="log-diff-line"><span class="log-key">${this.escapeHtml(fieldName)}</span>: ${afterHtmlBadge}</div>`);
               }
               return; // next field handled
             }

             // Si before está vacío/null y after es válido, mostrar solo after (ya manejado arriba para masivo)
             if ((!beforeHtmlBadge || before === null) && afterHtmlBadge) {
               lines.push(`<div class="log-diff-line"><span class="log-key">${this.escapeHtml(fieldName)}</span>: ${afterHtmlBadge}</div>`);
             } else {
               // Mostrar before -> after con badges (si ambos existen)
               const beforePart = beforeHtmlBadge || '<span class="log-diff-old">null</span>';
               const afterPart = afterHtmlBadge || '<span class="log-diff-new">null</span>';
               const valuesHtml = `${beforePart} <span class="log-diff-arrow">→</span> ${afterPart}`;
               lines.push(`<div class="log-diff-line"><span class="log-key">${this.escapeHtml(fieldName)}</span>: ${valuesHtml}</div>`);
             }

             return; // next field handled
           }

           const beforeHtml = before === null
             ? null
             : `<span class="log-diff-old">"${this.escapeHtml(String(before))}"</span>`;
           const afterHtml = after === null
             ? '<span class="log-diff-new">null</span>'
             : `<span class="log-diff-new">"${this.escapeHtml(String(after))}"</span>`;

           if (isRdsModif) {
             // Para "RDS Modif": mostrar solo el after, sin before ni flecha
             lines.push(`<div class="log-diff-line"><span class="log-key">${this.escapeHtml(fieldName)}</span>: ${afterHtml}</div>`);
           } else if (isGlobalMassive && before === null && afterHtml) {
             // mostrar solo after
             // Representar after como badge verde sin comillas
             const afterBadge = `<span class="log-diff-new">${this.escapeHtml(String(after))}</span>`;
             lines.push(`<div class="log-diff-line"><span class="log-key">${this.escapeHtml(fieldName)}</span>: ${afterBadge}</div>`);
           } else {
             const valuesHtml = `${beforeHtml || '<span class="log-diff-old">null</span>'} <span class="log-diff-arrow">→</span> ${afterHtml}`;
             lines.push(`<div class="log-diff-line"><span class="log-key">${this.escapeHtml(fieldName)}</span>: ${valuesHtml}</div>`);
           }
         });
       }
     }

     // Resto de propiedades de changes (sin fields)
     const otherKeys = Object.keys(changes).filter(k => k !== 'fields');
     if (otherKeys.length > 0) {
       const otherLines = otherKeys
         .filter(k => !this.shouldHideField(k, changes[k]))
         .map(k => this.formatSimpleValue(k, changes[k]))
         .filter(l => l !== null);
       if (otherLines.length > 0) {
         lines.push('<div class="log-props-block">' + otherLines.join('') + '</div>');
       }
     }

     return lines.join('');
   }

  // Helper para detectar y extraer items de un matchKey que venga como string entre corchetes o como array
  private extractMatchKeyItems(value: any): string[] | null {
    if (!value && value !== '') return null;
    // Si ya es array, devolverlo cast
    if (Array.isArray(value)) return value.map(v => String(v));
    if (typeof value === 'string') {
      const s = value.trim();
      // Caso JSON real: ["a","b"]
      if (s.startsWith('[') && s.endsWith(']')) {
        // intentar parsear como JSON
        try {
          const parsed = JSON.parse(s);
          if (Array.isArray(parsed)) return parsed.map(v => String(v));
        } catch {
          // no es JSON válido, seguir con split por comas
          const inner = s.slice(1, -1);
          const parts = inner.split(',').map(p => p.trim()).filter(p => p);
          return parts.length > 0 ? parts : null;
        }
      }
      // Si contiene coma y parece una lista, separarla
      if (s.includes(',') && s.split(',').length > 1) {
        return s.split(',').map(p => p.trim()).filter(p => p);
      }
      // Si contiene punto y coma, o espacios múltiples entre tokens, también tratar como lista
      if ((s.includes(';') && s.split(';').length > 1) || (/\s+/.test(s) && s.split(/\s+/).length > 1)) {
        // separar por ; o por espacios en blanco
        const parts = s.split(/[;,\s]+/).map(p => p.trim()).filter(p => p);
        return parts.length > 0 ? parts : null;
      }
    }
    return null;
  }

  // Helper que renderiza badges usando clases CSS y un único color para todos
  private renderBadges(items: string[]): string {
    if (!items || items.length === 0) return '';
    return items.map((it) => `
      <span class="log-diff-new matchkey-badge matchkey-color-0">${this.escapeHtml(it)}</span>
    `).join('');
  }

  // Helper que renderiza un solo badge (sin comillas) usando clase por defecto color-0
  private renderSingleBadge(item: string): string {
    if (!item) return '';
    return `
      <span class="log-diff-new matchkey-badge matchkey-color-0">${this.escapeHtml(item)}</span>
    `;
  }

  private formatSection(obj: any, sectionKey?: string): string {
    const lines: string[] = [];
    for (const key of Object.keys(obj)) {
      if (this.shouldHideField(key, obj[key], sectionKey)) continue;
      const line = this.formatSimpleValue(key, obj[key]);
      if (line !== null) lines.push(line);
    }
    return lines.length > 0 ? '<div class="log-props-block">' + lines.join('') + '</div>' : '';
  }

  private formatSimpleValue(key: string, value: any): string | null {
    const keyHtml = `<span class="log-key">${this.escapeHtml(key)}</span>`;

    if (value === null || value === undefined) {
      return `<div class="log-prop-line">${keyHtml}: <span class="log-null">null</span></div>`;
    } else if (Array.isArray(value)) {
      if (value.length === 0) {
        return `<div class="log-prop-line">${keyHtml}: <span class="log-bracket">[]</span></div>`;
      }
      const items = value.map(v =>
        typeof v === 'string'
          ? `<span class="log-string">"${this.escapeHtml(v)}"</span>`
          : `<span class="log-value">${this.escapeHtml(String(v))}</span>`
      );
      return `<div class="log-prop-line">${keyHtml}: <span class="log-bracket">[</span>${items.join(', ')}<span class="log-bracket">]</span></div>`;
    } else if (typeof value === 'object') {
      // Sub-objeto generico: renderizar propiedades indentadas
      const subLines = Object.keys(value)
        .filter(k => !this.shouldHideField(k, value[k]))
        .map(k => this.formatSimpleValue(k, value[k]))
        .filter(l => l !== null);
      if (subLines.length === 0) return null;
      return `<div class="log-prop-line">${keyHtml}:</div><div class="log-indent">${subLines.join('')}</div>`;
    } else if (typeof value === 'string') {
      // Manejo especial para matchKey que venga como string representando lista o valor único
      const isMatchKeyField = key && (key.toLowerCase() === 'matchkey' || key.toLowerCase() === 'match_key' || key.toLowerCase().includes('matchkey'));

      if (isMatchKeyField) {
        const matchItems = this.extractMatchKeyItems(value);
        if (matchItems && matchItems.length > 0) {
          const badges = this.renderBadges(matchItems);
          return `<div class="log-prop-line">${keyHtml}: ${badges}</div>`;
        }
        // Si la clave indica matchKey, mostrar como badge único (sin comillas)
        const badge = this.renderSingleBadge(value);
        return `<div class="log-prop-line">${keyHtml}: ${badge}</div>`;
      }

      return `<div class="log-prop-line">${keyHtml}: <span class="log-string">"${this.escapeHtml(value)}"</span></div>`;
    } else if (typeof value === 'number') {
      return `<div class="log-prop-line">${keyHtml}: <span class="log-number">${value}</span></div>`;
    } else if (typeof value === 'boolean') {
      return `<div class="log-prop-line">${keyHtml}: <span class="log-bool">${value}</span></div>`;
    }
    return `<div class="log-prop-line">${keyHtml}: <span class="log-value">${this.escapeHtml(String(value))}</span></div>`;
  }

  private escapeHtml(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  copyRawJson(rawJson: string) {
    navigator.clipboard.writeText(rawJson).then(() => {
      this.copySuccess = true;
      setTimeout(() => this.copySuccess = false, 2000);
    });
  }

}
